import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MissJonesCardData } from '../../../../../../../models/print-cards/miss-jones-card-data';
import { CannabinoidOrTerpeneFromPool } from '../../shared/card-data-with-property-pooling';

@Injectable()
export class MissJonesIndexCardStackContentViewModel extends PrintCardContentViewModel {
  public readonly cardData$: Observable<MissJonesCardData>;

  public readonly headerText$ = this.cardData$.pipe(map(cardData => cardData?.getHeaderText()));

  public experienceText$ = this.cardData$.pipe(
    map(cardData => {
      return cardData?.getExperienceText();
    })
  );

  public hasCraftDesignation$ = this.cardData$.pipe(map(cardData => cardData?.hasCraftDesignation()));

  public flavorNotes$ = this.cardData$.pipe(
    map(cardData => {
      return cardData?.getProductFlavors()?.join(', ') || '--';
    })
  );

  /**
   * Terpene notes is an override specific to this card's functionality. It always pulls present terpenes
   * directly from the card data, regardless of their enabled state on the card. Don't source this from the
   * compound pool, since present terpenes are intentionally excluded from it (see
   * addVisiblePresentTerpsToPrimaryPool below).
   */
  public terpeneNotes$ = this.cardData$.pipe(
    map(cardData => {
      return cardData?.getPresentTerpenes()?.join(', ') || '--';
    })
  );

  /**
   * The visible properties diverges from the pooling logic for this card, because terpene notes handles
   * the present terpenes logic outside the pool, and we don't want to show the present terpenes in the
   * properties section as well. Therefore, skip adding present terpenes to the pool.
   */
  protected override addVisiblePresentTerpsToPrimaryPool(
    _visiblePresentTerps: CannabinoidOrTerpeneFromPool | null,
    _maxProps: number,
    _properties: CannabinoidOrTerpeneFromPool[]
  ): void {
    return;
  }
}
